import { round } from 'es-toolkit';
// mantine
import { Divider } from '@mantine/core';
// utils
import type { TSessionSummaryStat } from '@newo/api/gateway';

// Number of decimal places to display for percentages
const DECIMAL_PLACES = 2;
const PERCENTAGE_MULTIPLIER = 100;

interface ByTimeProps {
    className?: string;
    data: TSessionSummaryStat;
}

const ByTime = ({ className, data }: ByTimeProps) => {
    let whPercentage = 0;
    let nwhPercentage = 0;

    if (data.total > 0) {
        whPercentage =
            (data.working_hours / data.total) * PERCENTAGE_MULTIPLIER;
        nwhPercentage =
            (data.non_working_hours / data.total) * PERCENTAGE_MULTIPLIER;
    }

    return (
        <div className={className}>
            <div className="font-semibold mb-1">by Time</div>
            <div>
                <div className="flex justify-between capitalize py-2 nw-format-number">
                    Working Hours
                    <span>
                        {data.working_hours} (
                        {round(whPercentage, DECIMAL_PLACES)}%)
                    </span>
                </div>
                <Divider />
                <div className="flex justify-between capitalize py-2 nw-format-number">
                    Non-Working Hours
                    <span>
                        {data.non_working_hours} (
                        {round(nwhPercentage, DECIMAL_PLACES)}%)
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ByTime;
